"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _utility = require("./utility");

var parse = function parse(dataOriginal) {
  var data = dataOriginal.media;
  var topics = [];
  var groups = [];
  var speakers = [];
  var transcript = [];
  var transcriptSpeakers = [];

  if (data.knowledge && data.knowledge.keywords && data.knowledge.keywords.words) {
    var _parseKeywordsArray = (0, _utility.parseKeywordsArray)(data.keywords.words),
        keywords = _parseKeywordsArray.keywords,
        keywordSpeakers = _parseKeywordsArray.speakers;

    topics.push({
      name: 'ALL TOPICS',
      type: 'category',
      keywords: keywords,
      speakers: keywordSpeakers
    });
    speakers = (0, _utility.addSpeakersToSpeakerArray)(speakers, keywordSpeakers);
  }

  if (data.keywords && data.keywords.groups) {
    var _parseTopicsArray = (0, _utility.parseTopicsArray)(data.keywords.groups),
        groupsArrayTopics = _parseTopicsArray.topics,
        groupsArraySpeakers = _parseTopicsArray.speakers;

    groups = groups.concat(groupsArrayTopics);
    speakers = (0, _utility.addSpeakersToSpeakerArray)(speakers, groupsArraySpeakers);
  }

  if (data.topics && data.topics.topics) {
    var _parseTopicsArray2 = (0, _utility.parseTopicsArray)(data.topics.topics),
        topicsArrayTopics = _parseTopicsArray2.topics,
        topicsArraySpeakers = _parseTopicsArray2.speakers;

    topics = topics.concat(topicsArrayTopics);
    speakers = (0, _utility.addSpeakersToSpeakerArray)(speakers, topicsArraySpeakers);
  }

  if (data.transcripts && data.transcripts.words) {
    var _parseWordsArray = (0, _utility.parseWordsArray)(data.transcripts.words),
        wordsArrayWords = _parseWordsArray.words,
        wordsArraySpeakers = _parseWordsArray.speakers,
        wordsArrayTranscriptSpeakers = _parseWordsArray.transcriptSpeakers;

    transcript = transcript.concat(wordsArrayWords);
    speakers = (0, _utility.addSpeakersToSpeakerArray)(speakers, wordsArraySpeakers);
    transcriptSpeakers = wordsArrayTranscriptSpeakers;
  }

  return {
    activeTopic: 0,
    topics: topics,
    activeGroup: 0,
    groups: groups,
    activeSpeaker: 0,
    speakers: speakers,
    transcriptSpeakers: transcriptSpeakers,
    transcript: transcript,
    // TODO: Implement classifiers in v2 if required later.
    // They are mixed in with other predictions though which makes it hard.
    classifiers: null
  };
};

var _default = parse;
exports["default"] = _default;